// contexts/User/index.jsx

import { SearchkitHit } from "@searchkit/sdk";
import React, { useState } from "react";

export const MapContext = React.createContext<{
  popup: SearchkitHit | undefined;
  setPopup: React.Dispatch<React.SetStateAction<SearchkitHit | undefined>>;
}>({
  popup: undefined,
  setPopup: () => {},
});

export const MapProvider: React.FC = ({ children }) => {
  const [popup, setPopup] = useState<SearchkitHit | undefined>();

  return (
    <MapContext.Provider value={{ popup, setPopup }}>
      {children}
    </MapContext.Provider>
  );
};
